import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ImportMembers from "../../components/Open-pages/import-members/ImportMembers";

const ImportMembersOpen = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isNotificationDenied = useSelector(
    (state) => state.notification.permission
  );

  const [pageState, setPageState] = useState(
    JSON.parse(localStorage.getItem("pageState"))
  );
  const { decryptedText: userInfoData, isCustom } = pageState || {};

  const isIOS = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  const onClickBackBtn = (e) => {
    e.preventDefault();
    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  useEffect(() => {
    const savedState = localStorage.getItem("pageState");

    if (savedState) {
      try {
        setPageState(JSON.parse(savedState));
      } catch (error) {
        console.error("Error parsing saved state:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!pageState) {
      navigate("/open-access", { state: { from: location.pathname } });
    }
  }, [pageState]);

  return (
    <ImportMembers
      decryptedText={userInfoData}
      isNotificationDenied={isNotificationDenied}
      isIOS={isIOS}
      onClickBackBtn={onClickBackBtn}
      isCustom={isCustom}
    />
  );
};

export default ImportMembersOpen;
